<script>
  import { useParams } from "svelte-navigator";
  import { getContext, onMount } from "svelte";
  import { fetchDispatchingViewResources, FetchError, } from "../../../utils/getData.js";
  import { usePageContext } from "../../../components/pages/pageContext.js";
  import { translate } from "../../../i18n/i18next.js";
  import { navigateI18n } from "../../../i18n/navigate.js";
  import {
    getDispatchingViewConfiguration
  } from "../../../utils/configurationStorage/views/DispatchingViewConfigurationStorage.js";

  export let user;

  const params = useParams();
  const projectId = $params.project;
  const { setHeaderProps } = usePageContext();
  setHeaderProps({ title: translate("frontend:views.dispatchingView.resourceSelection") });

  const { handleFetchErrors } = getContext("fetchErrorHandler");
  onMount(async () => {
    try {
      const {resources, isCustomizedForProfile1} = await fetchDispatchingViewResources(projectId)

      // If the data is from Profile1 user, use the customized version of DispatchingView.
      if (isCustomizedForProfile1) {
        navigateI18n(`/projects/${projectId}/DispatchingView_Profile1`, {replace: true});
        return
      }

      const savedSettings = getDispatchingViewConfiguration(user.id, projectId);
      let viewDates = savedSettings?.viewDates;
      if (viewDates && viewDates.length > 0)  {
        // Find resourceObjectID with the newest view date
        const tempViewDates = [...viewDates];
        tempViewDates.sort((a, b) => {
          const aDate = new Date(a.viewDate)
          const bDate = new Date(b.viewDate)
          return aDate > bDate ? 1 : -1;
          // in a year or so, we should replace the above with the following
          // everyone needs to understand the difference between "date" and "point in time"...
          // return a.viewDate.localeCompare(b.viewDate)
        })

        let lastSelectedObjectId = tempViewDates.at(-1).resourceObjectID
        if (resources.find(res => Number(res.objectId) == lastSelectedObjectId)) {
          navigateI18n(`/projects/${projectId}/DispatchingView/${lastSelectedObjectId}`, {replace: true});
          return;
        } 
      }
      // If no view dates stored, or the stored resource object id does not exist, navigate to the first resource
      navigateI18n(`/projects/${projectId}/DispatchingView/${resources[0].objectId}?firstVisit=true`, {replace: true});
    } catch (e) {
      console.error(e);
      if (e instanceof FetchError) {
        handleFetchErrors(e.error);
      }
    }
  });
</script>
